import { Dialog, IconButton } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { HEADER_HEIGHT } from '@sm/layout';
import { isSmallSize } from '@sm/WindowSizes';
import Colors from 'styles/colors';
import { ModernCancelConfirmButtons } from '../buttons';
import { CrossSolidIcon } from '../icons';

const ModernDialog = ({
  open,
  title,
  content,
  onCancel,
  onConfirm,
  confirmActive,
  cancelText,
  confirmText,
  hideCrossIcon,
  hideCancelButton,
  fullWidth,
  maxWidth,
  hideHeader,
  fullScreenOnMobile = false
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      style={{ top: HEADER_HEIGHT }}
      fullScreen={isSmallSize() && fullScreenOnMobile}
    >
      <div className="p-6">
        <div
          className={classNames('flex items-center justify-between mb-8', { hidden: hideHeader })}
        >
          <div className="text-large font-medium text-gray-darkest flex-grow">{title}</div>
          {!hideCrossIcon && (
            <IconButton className="p-1 ml-4 -mr-1" onClick={onCancel}>
              <CrossSolidIcon fill={Colors.gray.dark} />
            </IconButton>
          )}
        </div>
        {content}
      </div>
      <ModernCancelConfirmButtons
        onCancel={onCancel}
        onConfirm={onConfirm}
        cancelText={cancelText}
        confirmText={confirmText}
        confirmActive={confirmActive}
        hideCancelButton={hideCancelButton}
      />
    </Dialog>
  );
};

ModernDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  confirmActive: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  content: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  hideCrossIcon: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hideCancelButton: PropTypes.bool,
  maxWidth: PropTypes.string,
  fullScreenOnMobile: PropTypes.bool,
  hideHeader: PropTypes.bool
};

ModernDialog.defaultProps = {
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  hideCrossIcon: false,
  fullWidth: false,
  hideCancelButton: false,
  maxWidth: undefined,
  fullScreenOnMobile: false,
  hideHeader: false
};

export default ModernDialog;
